import _ from 'lodash';

class Access {
	constructor(perms = []) {
		this.endpoint = prefix_url('permissions/user/check');
		this.permissions = perms;

		if (this.permissions.length <= 0) {
			this.permissions = _.defaultTo(PAGE_CONFIG.perms, []);
		}

		this.user = CONFIG._logged_in_user;
	}
	
	/**
	 * Determines if user is a developer.
	 */
	isDeveloper() {
		return this.user.role_id == 2;
	}
	
	/**
	 * Determines if user is a super admin.
	 */
	isSuperAdmin() {
		if (this.isDeveloper()) {
			return true;
		}
		
		return this.user.role_id == 1 && this.user.active_company == 1;
	}
	
	/**
	 * Determine if user belongs to company.
	 * 
	 * @param {integer} company_id
	 * @param {bool} debug
	 */
	company(company_id, debug = false) {
		if (debug) {
			if (this.isDeveloper()) {
				return true;
			}
		}
		
		return this.user.active_company == company_id;
	}

	/**
	 * Add permissions to check.
	 *
	 * @param {array} perms
	 */
	addPerms(perms) {
		this.permissions = _.merge(this.permissions, perms);
	}

	/**
	 * Determine if user is allowed to do something
	 *
	 * @param {string} perm
	 */
	allow(perm) {
		if (! _.isNil(this.permissions[perm])) {
			return this.permissions[perm];
		}

		console.log('not in array: ' + perm);
		return false;
	}

	/**
	 * Determine if user is allowed to do multiple actions.
	 *
	 * @param {array} perms
	 * @param {bool} needs_all
	 */
	allowMultiple(perms, needs_all = false) {
		if (! _.isArray(perms)) {
			perms = [perms];
		}

		if (needs_all) {
			let num_perms = perms.length;
			let has_perms = 0;

			_.forEach(perms, (perm) => {
				if (this.allow(perm)) {
					has_perms++;
				}
			});

			return has_perms === num_perms;
		}

		let allow = false;
		_.forEach(perms, (perm) => {
			if (! allow) {
				if (this.allow(perm)) {
					allow = true;
					return false;
				}
			}
		});

		return allow;
	}

	check(perms) {
		axios.get(this.endpoint, {
			params: {
				perms: perms
			}	
		})
		.then(({data}) => {
			this.setPermissions(data);
			return data;
		})
		.catch(error => {
			console.log(error);
		});
	}
	
	setPermissions(data) {
		this.permissions = data;
	}
}
export default Access;